/// <reference path='../_all.ts' />

module partner {
  'use strict';

  export class Area {
    constructor(
      public ID: number,
      public Name: string,
      public Desc: string,
      public BusinessAreas: BusinessArea[],
      public Vendors: VendorWBusinessArea[]
      ) { }
  }
}

